import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const durationFormat = seconds => {
  var hrs = ~~(seconds / 3600)
  var mins = ~~((seconds % 3600) / 60)
  var secs = ~~seconds % 60

  var duration = ''

  if (hrs > 0) {
    duration += '' + hrs + ':' + (mins < 10 ? '0' : '')
  }

  duration += '' + mins + ':' + (secs < 10 ? '0' : '')
  duration += '' + secs
  return duration
}

class Video extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isPlaying: false,
      duration: false,
    }

    this.videoRef = React.createRef()
    this.iframeRef = React.createRef()

    this.loadedMetaData = this.loadedMetaData.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    if (this.videoRef.current != null) {
      this.videoRef.current.addEventListener(
        'loadedmetadata',
        this.loadedMetaData
      )
    }
  }

  loadedMetaData() {
    if (this.videoRef.current != null) {
      const seconds = this.videoRef.current.duration
      this.setState({ duration: durationFormat(seconds) })
    }
  }

  handleClick() {
    if (this.videoRef.current != null) {
      this.videoRef.current.play()
    }

    if (
      this.iframeRef.current != null &&
      this.iframeRef.current.contentWindow
    ) {
      this.iframeRef.current.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      )
    }

    this.setState({ isPlaying: true })
  }

  render() {
    const {
      title,
      url,
      yt_id,
      thumbnail,
      thumbnailTitle,
      videoDescription,
      style,
    } = this.props
    const { isPlaying, duration } = this.state

    return (
      <div className="dhsv_video_container">
        <div className={`dhsv_video -${style}`}>
          {!yt_id ? (
            <video ref={this.videoRef} controls playsInline>
              <source src={url} type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>
          ) : (
            <iframe
              ref={this.iframeRef}
              uc-src={url + yt_id}
              frameBorder="0"
              allowFullScreen
              allowscriptaccess="always"
            />
          )}
          {!isPlaying && (
            <div
              className="ctnwrapper lazyload"
              data-bg={thumbnail}
              onClick={this.handleClick}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: thumbnailTitle ? thumbnailTitle : title,
                }}
              />
              {style === 'button' && (
                <div className="btncon">
                  <svg
                    xlmns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                  >
                    <path d="M20,10 80,50 20,90 z" />
                  </svg>
                </div>
              )}
              {duration && (
                <div className="duration">
                  <span>{duration} min</span>
                </div>
              )}
            </div>
          )}
        </div>
        {videoDescription && <span>{videoDescription}</span>}
      </div>
    )
  }
}

Video.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  yt_id: PropTypes.string,
  thumbnail: PropTypes.string,
  thumbnailTitle: PropTypes.string,
  videoDescription: PropTypes.string,
  style: PropTypes.string,
}

export default Video
